import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Check } from 'assets/svg/icon-check.svg'

function IconCheck(props: IconProps): JSX.Element {
  const title = 'icon-check'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Check {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconCheck
